import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ForecastNotAvailableDesc, LatestResultIconsDesktop, PollutionForecastTypes, WeatherForecastIcons } from 'src/app/models/app-constants';
import { convertToAESTDateTime, getForecastDateDescription, getPollutionForecastDescText, getTimezoneOffset } from '../utils';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { AppMonitoringService } from 'src/app/services/logging.service';

@Component({
	selector: 'app-site-info-widget',
	templateUrl: './site-info-widget.component.html',
	styleUrls: ['./site-info-widget.component.scss']
})
export class SiteInfoWidgetComponent implements OnInit, OnChanges {
	@Input() isFavouriteScreen: boolean = false;
	@Input() showScreenshot : boolean = false;		
	@Input() sitePopupInfo: SitePopupInfoModel;
	@Input() mobileView?: boolean = false;
	@Input() sitePhoto : string = "";

	@Input() closable: boolean = false;
	@Output() closed: EventEmitter<any> = new EventEmitter<any>();

	constructor(private appMonitoringService: AppMonitoringService) {}

	@ViewChild("siteAnchorLink", { read: ElementRef }) siteAnchorLink: ElementRef;

	latestResultDate = new Date(2022, 9, 20);
	wrapperClass: string = "wq-v2-mobile-master";
	titleBlockClass: string = "frame-2121";
	pollLevelIndicatorIcon: string = "Unavailable.svg";
	latestResultRatingIcon: string = "";

	timeZoneOffset = getTimezoneOffset();

	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges): void {
		switch (this.sitePopupInfo?.PollutionForecast) {
			case PollutionForecastTypes.POLLUTION_LIKELY:
				this.wrapperClass = "wq-v2-mobile-master-pollution-likely";
				this.titleBlockClass = "frame-2121-pollution-likely";
				this.pollLevelIndicatorIcon = "Red.svg";
				break;
			case PollutionForecastTypes.POLLUTION_UNLIKELY:
				this.wrapperClass = "wq-v2-mobile-master-pollution-unlikely";
				this.titleBlockClass = "frame-2121-pollution-unlikely";
				this.pollLevelIndicatorIcon = "Green.svg";
				break;
			case PollutionForecastTypes.POLLUTION_POSSIBLE:
				this.wrapperClass = "wq-v2-mobile-master-pollution-possible";
				this.titleBlockClass = "frame-2121-pollution-possible";
				this.pollLevelIndicatorIcon = "Yellow.svg";
				break;
			case PollutionForecastTypes.DATA_UNAVAILABLE:
				this.wrapperClass = "wq-v2-mobile-master-pollution-data-unavailable";
				this.titleBlockClass = "frame-2121-pollution-data-unavailable";
				this.pollLevelIndicatorIcon = "Unavailable.svg";
				break;
			default:
				this.wrapperClass = "wq-v2-mobile-master-pollution-data-unavailable";
				this.titleBlockClass = "frame-2121-pollution-data-unavailable";
				this.pollLevelIndicatorIcon = "Unavailable.svg";
				break;
		}

		switch (this.sitePopupInfo?.LatestResultStarRating) {
			case 1:
				this.latestResultRatingIcon = LatestResultIconsDesktop.get("Bad") ?? "";
				break;
			case 2:
				this.latestResultRatingIcon = LatestResultIconsDesktop.get("Poor") ?? "";
				break;
			case 3:
				this.latestResultRatingIcon = LatestResultIconsDesktop.get("Ok") ?? "";
				break;
			case 4:
				this.latestResultRatingIcon = LatestResultIconsDesktop.get("Good") ?? "";
				break;
			default:
				this.latestResultRatingIcon = "";
		}
	}

	ngAfterViewInit(): void {
		this.siteAnchorLink?.nativeElement?.focus();
	}

	get forecastBriefDesc(): string {
		return getForecastDateDescription(this.sitePopupInfo?.PollForecastDateTime);

		// if (this.sitePopupInfo && this.sitePopupInfo?.PollForecastDateTime &&
		// 	"function" === typeof (this.sitePopupInfo?.PollForecastDateTime?.getTime) &&
		// 	"Invalid Date" !== this.sitePopupInfo?.PollForecastDateTime?.toString()) 
		// {
		// 	return "Forecast for " + getForecastDateDescription(this.sitePopupInfo?.PollForecastDateTime);
		// }
		// else
		// {
		// 	return ForecastNotAvailableDesc;
		// }		
	}


	get pollutionForecastText() 
	{
		return getPollutionForecastDescText(this.sitePopupInfo?.PollutionForecast);		
	}

	get lastUpdatedDate(): Date | undefined {
		if (this.sitePopupInfo && this.sitePopupInfo?.PollForecastDateTime &&
			"function" === typeof (this.sitePopupInfo?.PollForecastDateTime?.getTime) &&
			"Invalid Date" !== this.sitePopupInfo?.PollForecastDateTime?.toString()) {
			return this.sitePopupInfo?.PollForecastDateTime;
		}

		return undefined;
	}

	get siteImage(): string {
		const base64 = "data:image/png;base64," + (this.sitePhoto || "");
		return base64;
	}

	getWeatherForecastIcon(): string {
		const icon = WeatherForecastIcons.get(this.sitePopupInfo?.WeatherForecast?.ForecastIconCode ?
			Number(this.sitePopupInfo?.WeatherForecast?.ForecastIconCode) : 0);

		return icon ?? "";
	}

	onCloseButtonClicked = (event: any) => {
		this.closed.emit(event);
	}

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (this.closable && "Escape" === event.key) {
			this.onCloseButtonClicked(event);
		}
	}

	onSitelinkClicked = (id: any) => {
		if (this.mobileView) {
			// In mobile view body scrolling is disabled by setting style.overflow to hidden, so restore it
			// main-nav-active is class defined in NSW design scss
			if (document.body.classList.contains("main-nav-active")) {
				document.body.classList.remove("main-nav-active");
			}
			//document.body.style.overflow = "auto";			
		}

		this.appMonitoringService.logEvent('SiteDetailsLoadFromPopup',{'site_identifier': id})
	}

	getLocalDateTime = (dateTime : any) => {
		return convertToAESTDateTime(dateTime);		
	}
}
